import REMOVE_COTTAGE_STAY_FROM_CART from "../../graphql/mutations/removeCottageStayFromCart";
import {useMutation} from "@apollo/react-hooks";
import {getSessionId} from "../../services/session";
import React from "react";
import {Button} from "reactstrap";

const RemoveFromCartButton = ({stayId, onClick}) => {
    const [removeCottageStayFromCart] = useMutation(REMOVE_COTTAGE_STAY_FROM_CART);
    const uuid = getSessionId();

    return (
        <Button
            onClick={(e) => {
                e.stopPropagation();
                removeCottageStayFromCart({
                    variables: {
                        uuid: uuid,
                        stayId: stayId,
                    }
                })
                onClick();
            }
            }
            aria-label="Verwijder cottage"
            className="book-button p-0"
            color="link"
            size="sm"
        >
            Verwijder uit winkelwagen
            {" "}
            <i className="fas fa-trash-alt"/>
        </Button>
    )
}

export default RemoveFromCartButton;
